import axios from 'axios';

const LandingApi = async (
  token,
  fromDate: Date = null,
  toDate: Date = null,
) => {
  const config = {
    headers: {
      jtoken: token,
    },
  };
  try {
    const { data, status } = await axios.post(
      `${process.env.REACT_APP_HOST}report/transport/landing`,
      {
        fromDate,
        toDate,
      },
      config,
    );
    return { data, status };
  } catch (error) {
    return { data: error.request, status: error.request.status };
  }
};

export default LandingApi;
